import { useState, useEffect } from "react";
import { ArrowRight, Globe } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function OurSchoolsPage() {
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/schools`)
      .then(res => setSchools(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="our-schools-page">
      <section className="bg-[#1C2E4A] py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="text-xs uppercase tracking-[0.2em] text-[#C8A97E] font-semibold mb-3">Our Network</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-3xl">
            Our Schools
          </h1>
          <p className="mt-4 text-base text-white/60 max-w-2xl">
            Church schools built and powered by ACS Virtual Church. Each school is independently owned and operated by its church.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          {loading ? (
            <div className="text-center py-16 text-[#595959]">Loading schools...</div>
          ) : schools.length === 0 ? (
            <div className="text-center py-16">
              <Globe className="w-10 h-10 text-[#E5E2DC] mx-auto mb-3" />
              <p className="text-[#595959]">Our school network is growing. Check back soon!</p>
            </div>
          ) : (
            <div className="space-y-8">
              {schools.map((school, i) => (
                <div
                  key={school.id}
                  data-testid={`school-card-${i}`}
                  className="bg-[#FAF9F6] rounded-xl border border-[#E5E2DC] p-8 md:p-10 hover:shadow-md transition-shadow"
                >
                  <div className="flex items-start justify-between mb-4">
                    <div>
                      <h2 className="font-serif text-2xl sm:text-3xl font-semibold text-[#1C2E4A]">
                        {school.name}
                      </h2>
                    </div>
                    <Globe className="w-5 h-5 text-[#C8A97E] shrink-0 mt-1" />
                  </div>
                  <p className="text-sm text-[#595959] leading-relaxed mb-6">
                    {school.description}
                  </p>
                  {school.tags && school.tags.length > 0 && (
                    <div className="flex flex-wrap gap-2 mb-6">
                      {school.tags.map((tag, j) => (
                        <span
                          key={j}
                          className="text-xs bg-[#1C2E4A]/5 text-[#1C2E4A] px-3 py-1.5 rounded-full font-medium"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  )}
                  {school.website_url && (
                    <a
                      href={school.website_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`school-link-${i}`}
                      className="inline-flex items-center gap-2 bg-[#C8A97E] text-white hover:bg-[#B3956A] px-6 py-2.5 rounded-md transition-colors font-medium text-sm"
                    >
                      Visit Website <ArrowRight className="w-4 h-4" />
                    </a>
                  )}
                </div>
              ))}
            </div>
          )}

          {schools.length > 0 && (
            <div className="mt-12 text-center">
              <p className="text-sm text-[#595959]">
                Want your church school listed here?{" "}
                <a href="/start-a-church-school" className="text-[#C8A97E] hover:underline font-medium">
                  Start a Church School
                </a>
              </p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
